// import {useState, useEffect, useRef} from "react";
// import SectionTitleTwo from '../../components/SectionTitles/SectionTitleTwo';
// import AccordionWrap from '../../components/Accordion/AccordionWrap.jsx';
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';

// const Faq = () => {
//     const [scale] = useState(1.04);
//     const sceneEl = useRef(null);
//     useEffect(() => {
//         const parallaxInstance = new Parallax(sceneEl.current, {
//         relativeInput: true,
//         })

//         parallaxInstance.enable();

//         return () => parallaxInstance.disable();

//     }, [])
//     return (
//         <div className="faq-section section section-padding-top bg-primary-blue">
//             <div className="container">
//                 <div className="row row-cols-lg-2 row-cols-1 mb-n6">
//                     <div className="col mb-6" data-aos="fade-up">
//                         <div className="faq-content">
//                             <SectionTitleTwo 
//                                 subTitle="Our Engagements"
//                                 title="Representative Engagements"
//                             />

//                             <AccordionWrap />

//                         </div>
//                     </div>

//                     <div className="col mb-6 pl-xl-12" data-aos="fade-up" data-aos-delay="300">
//                         <div className="about-image-area faq-image-area">
//                             <div className="about-image right-n50">
//                                 <Tilt scale={scale} transitionSpeed={4000}>
//                                     <img src={process.env.PUBLIC_URL + "/images/faq/faq-2.jpg"} alt="" />
//                                 </Tilt>
//                             </div>
//                             <div className="about-image">
//                                 <Tilt scale={scale} transitionSpeed={4000}>
//                                     <img src={process.env.PUBLIC_URL + "/images/faq/faq-1.jpg"} alt="" />
//                                 </Tilt>
//                             </div>
//                             <div className="shape shape-1" id="scene" ref={sceneEl}>
//                                 <span data-depth="1"><img src={process.env.PUBLIC_URL + "/images/shape-animation/video-shape-1.png"} alt="" /></span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Faq;



// import {useState, useEffect, useRef} from "react";
// import SectionTitleTwo from '../../components/SectionTitles/SectionTitleTwo';
// import AccordionWrap from '../../components/Accordion/AccordionWrap.jsx';
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';
// import imgOne from '../../assets/images/faq/faq-1.jpg'
// import imgTwo from '../../assets/images/faq/faq-1.jpg'



// const Faq = () => {
//     const [scale] = useState(1.04);
//     // const sceneEl = useRef(null);
//     // useEffect(() => {
//     //     const parallaxInstance = new Parallax(sceneEl.current, {
//     //     relativeInput: true,
//     //     })

//     //     parallaxInstance.enable();

//     //     return () => parallaxInstance.disable();

//     // }, [])
//     return (
//         <div className="faq-section section section-padding-top bg-primary-blue">
//             <div className="container">
//                 <div className="row row-cols-lg-2 row-cols-1 mb-n6">
//                     <div className="col mb-6" data-aos="fade-up">
//                         <div className="faq-content">
//                             <SectionTitleTwo 
//                                 subTitle="Our Engagements"
//                                 title="Representative Engagements"
//                             />

//                             <AccordionWrap />

//                         </div>
//                     </div>

//                     <div className="col mb-6 pl-xl-12" data-aos="fade-up" data-aos-delay="300">
//                         <div className="about-image-area faq-image-area">
//                             {/* <div className="about-image right-n50">
//                                 <Tilt scale={scale} transitionSpeed={4000}>
//                                     <img src={process.env.PUBLIC_URL + "/images/faq/faq-2.jpg"} alt="" />
//                                 </Tilt>
//                             </div> */}
//                             {/* <div className="about-image">
//                                 <Tilt scale={scale} transitionSpeed={4000}>
//                                     <img src={process.env.PUBLIC_URL + "/images/faq/faq-1.jpg"} alt="" />
//                                 </Tilt>
//                             </div> */}
//                              <div className="about-image">
//                                 {/* <Tilt scale={scale} transitionSpeed={4000}> */}
//                                     <img src={process.env.PUBLIC_URL + "/images/faq/faq-3.png"} alt="" />
//                                 {/* </Tilt> */}
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Faq;



import { useState } from "react";
import SectionTitleTwo from "../../components/SectionTitles/SectionTitleTwo";
import AccordionWrap from "../../components/Accordion/AccordionWrap.jsx";
import imgOne from "../../assets/images/faq/eng_1.png";
import imgTwo from "../../assets/images/faq/eng_2.png";
import imgThree from "../../assets/images/faq/eng_3.png";
import imgFour from "../../assets/images/faq/eng_4.png";
import imgFive from "../../assets/images/faq/eng_5.png";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // NEW ORDER: eng5, eng2, eng1, eng3, eng4
  const images = [imgFive, imgTwo, imgOne, imgThree, imgFour];

  return (
    <div className="faq-section section section-padding-top bg-primary-blue">
      <div className="container">
        <div className="row row-cols-lg-2 row-cols-1 mb-n6">
          {/* LEFT */}
          <div className="col mb-6" data-aos="fade-up">
            <div className="faq-content">
              <SectionTitleTwo
                subTitle="Our Engagements"
                title="Representative Engagements"
              />
              <AccordionWrap onSelect={setActiveIndex} />
            </div>
          </div>

          {/* RIGHT */}
          <div
            className="col mb-6 pl-xl-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-image-area faq-image-area">
              <div className="about-image">
                <img
                  key={activeIndex}
                  src={images[activeIndex]}
                  alt="Engagement visual"
                  style={{
                    width: "100%",
                    borderRadius: "12px",
                    transition: "opacity 0.35s ease",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;